import Stripe from 'stripe';

export function convertBase64ToBlob(base64Image: string) {
    // Split into two parts
    const parts = base64Image.split(';base64,');

    // Hold the content type
    const imageType = parts[0].split(':')[1];

    // Decode Base64 string
    const decodedData = window.atob(parts[1]);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
    }

    // Return BLOB image after conversion
    return new Blob([uInt8Array], { type: imageType });
}

const stripe = new Stripe(
  'sk_test_51SfWkqP8xoqFWxRRQ7sXLyHKKquupNoVCamjwXQhPLtkh6HKR8TTIXFJ0hjeXUuxqtfZvvJeNzJLKoLO2buUurKZ00EqnM6Eus',
  {
    // apiVersion: '2024-06-20',
    typescript: true,
  }
);

interface UpcomingInvoiceResource extends Stripe.InvoicesResource {
  retrieveUpcoming: (
    params?: object,
    options?: Stripe.RequestOptions
  ) => Promise<Stripe.Invoice>;
}


export async function getActiveSubscriptionByEmail(email: string) {
  let periodEndTimestamp: number = 0;

  try {
    const customers = await stripe.customers.list({
      email: email,
      limit: 1,
    });
    const customer = customers.data[0];
    if (!customer) return null;

    const subscriptions = await stripe.subscriptions.list({
      customer: customer.id,
      status: 'all',
      limit: 1,

      expand: ['data.items.data.price', 'data.default_payment_method'],
    });

    const activeSubscription = subscriptions.data.find(
      (sub) => sub.status === 'active' || sub.status === 'trialing'
    );
    if (!activeSubscription) return null;

    const firstItem = activeSubscription.items.data[0];
    const price = firstItem?.price as Stripe.Price;

    const productId = price?.product as string;

    if (
      !productId ||
      !price ||
      !price.unit_amount ||
      !price.recurring?.interval
    ) {
      console.error(
        'Subscription item or its data is incomplete (Price ID or Price details missing).'
      );
      return null;
    }

    let product: Stripe.Product;
    try {
      product = await stripe.products.retrieve(productId);
    } catch (e) {
      console.error('Failed to retrieve Product details:', e);

      product = {
        id: productId,
        name: 'Unknown Plan',
        object: 'product',
      } as Stripe.Product;
    }

    try {
      const invoicesResource =
        stripe.invoices as unknown as UpcomingInvoiceResource;

      const upcomingInvoice = await invoicesResource.retrieveUpcoming({
        customer: customer.id,
        subscription: activeSubscription.id,
      });

      periodEndTimestamp =
        upcomingInvoice.period_end || upcomingInvoice.next_payment_attempt || 0;
    } catch (e) {
      console.warn(
        'Could not retrieve upcoming invoice. Using anchor as fallback.'
      );
      periodEndTimestamp = activeSubscription.billing_cycle_anchor;
    }

    if (periodEndTimestamp === 0) {
      periodEndTimestamp = activeSubscription.created;
    }

    return {
      email: email,
      plan: product.name,
      status: activeSubscription.status,
      price: `$${(price.unit_amount / 100).toFixed(2)} / ${
        price.recurring.interval
      }`,
      current_period_end: periodEndTimestamp * 1000,
      test: true,
    };
  } catch (error) {
    console.error('Stripe API Error:', error);
    throw new Error('Failed to retrieve subscription data from Stripe.');
  }
}